import styled, { css } from 'styled-components';
import { Box, TabList, SideSheetContentCol, SideSheetSubHeaderStyled as SideSheetSubHeader } from '@bechtel/gds';

interface DocumentLinkStyledProps {
  isSelected: boolean;
}

export const InfoContainerStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  width: 100%;
  height: 100%;
`;

export const SubHeaderStyled = styled(SideSheetSubHeader)`
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
  z-index: 2;
`;

export const DocumentLinkStyled = styled.div<DocumentLinkStyledProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  display: block;
  padding: ${({ theme }) => theme.spacings[500]};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.blue[100]};
    `}
`;

export const SideSheetDocumentHeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.grey[200]};
  `}
`;

export const SideSheetContentColStyled = styled(SideSheetContentCol)`
  z-index: 1;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);
  max-width: 360px;
`;

export const TabListStyled = styled(TabList)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey['300']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
`;

export const DocumentHeaderStyled = styled(Box).attrs({
  p: { sm: '600' },
  flexDirection: { sm: 'column' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[100]};
`;
